import { Link } from "react-router-dom";
import FadeIn from "@/components/FadeIn";
import { ArrowRight, Clock, Eye, ShieldCheck } from "lucide-react";

const PROMISES = [
  { icon: Clock, text: "Réponse personnelle sous 24 h ouvrées" },
  { icon: Eye, text: "Estimation affinée lors d'une visite confidentielle" },
  { icon: ShieldCheck, text: "Vos données ne sont jamais cédées à des tiers" },
];

export default function AdvisorProfile() {
  return (
    <section id="conseiller" data-testid="advisor-section" className="border-t border-stone-800/60 bg-[#0e0e11]">
      <div className="mx-auto max-w-4xl px-6 py-24 text-center lg:py-32">
        <FadeIn>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D4AF37]/80">L'humain derrière la donnée</p>
          <h2 className="font-display mx-auto mt-4 max-w-2xl text-2xl font-normal tracking-tight text-amber-100 sm:text-3xl lg:text-4xl">
            Un conseiller <em className="text-[#D4AF37]">dédié,</em> pas un automate.
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-stone-400">
            Chaque estimation est relue par un conseiller en immobilier de prestige qui connaît
            votre secteur. Après votre demande, c'est lui — et lui seul — qui vous recontacte,
            avec votre accord, pour affiner la valeur de votre bien.
          </p>
        </FadeIn>
        <div className="mx-auto mt-12 grid max-w-3xl grid-cols-1 gap-4 text-left sm:grid-cols-3">
          {PROMISES.map((p, i) => (
            <FadeIn key={p.text} delay={0.1 + i * 0.08}>
              <div data-testid={`advisor-promise-${i}`} className="h-full border border-stone-800 bg-[#141417] p-6">
                <span className="flex h-10 w-10 items-center justify-center border border-[#D4AF37]/30">
                  <p.icon size={16} className="text-[#E5C158]" strokeWidth={1.5} />
                </span>
                <p className="mt-4 text-sm leading-relaxed text-stone-300">{p.text}</p>
              </div>
            </FadeIn>
          ))}
        </div>
        <FadeIn delay={0.4}>
          <Link to="/estimation" data-testid="advisor-cta-estimation" className="btn-gold mt-12">
            Demander mon estimation <ArrowRight size={16} />
          </Link>
        </FadeIn>
      </div>
    </section>
  );
}
